import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { useRecoilValue } from 'recoil';
import { themeSelector } from '@/state/config';
import styles from './WelcomeGreeting.module.scss';
export const WelcomeGreeting = ({ greeting }) => {
    const theme = useRecoilValue(themeSelector);
    return _jsx("div", { className: cn(styles.container, styles[theme]), children: greeting });
};
